export default __webpack_public_path__ + "static/media/loading.cafeefe4.gif";